import React from 'react';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-gray-800 dark:text-gray-200 px-4">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-xl font-semibold mb-2">Page not found :(</p>
      <p className="text-md">The requested page could not be found.</p>
    </div>
  );
}
